import store from '../../store'
import GenericDataService from '@/services/GenericDataService'

export default [
    {
        path: 'facturation',
        meta: { titleDocument: "facturation" },
        redirect: { name: 'Invoices' },
        component: function () {
            return import(/* webpackChunkName: "Facturation" */ /* webpackPrefetch: true */'../../modules/facturation/views/Facturation.vue')
        },
        beforeEnter: (to, from, next) => {
            GenericDataService.getData('/menu/getsubmenu?module=facturation').then((response) => {
                let submenu = response.data.data;
                store.dispatch('base/SET_SUB_MENU', submenu)
                next();
            })
        },
        children: [
            {
                path: 'invoices',
                name: 'Invoices',
                meta: { title: 'Invoices', titleDocument: "invoices", rights: ["facturation/menu"] },
                component: function () {
                    return import(/* webpackChunkName: "Invoices" */ /* webpackPrefetch: true */'../../modules/facturation/views/Invoices.vue')
                },
                beforeEnter: (to, from, next) => {
                    GenericDataService.getData('/menu/getsubmenu?module=facturation').then((response) => {
                        let submenu = response.data.data;
                        store.dispatch('base/SET_SUB_MENU', submenu)
                        next();
                    })
                },
            },
            {
                path: 'usagedetails',
                name: 'UsageDetails',
                meta: { title: 'UsageDetails', titleDocument: "usageDetails", rights: ["facturation/menu"] },
                component: function () {
                    return import(/* webpackChunkName: "UsageDetails" */ /* webpackPrefetch: true */'../../modules/facturation/views/UsageDetails.vue')
                },
            },
            {
                path: 'usagetracking',
                name: 'UsageTracking',
                meta: { title: 'UsageTracking', titleDocument: "usageTracking", rights: ["facturation/menu"] },
                component: function () {
                    return import(/* webpackChunkName: "UsageTracking" */ /* webpackPrefetch: true */'../../modules/facturation/views/UsageTracking.vue')
                },
            }
        ]
    }
]